// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("@img/box-questionmark.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".dialog-subtitle[data-v-4fa986e5]{margin-top:20px;padding-bottom:0}.back-btn[data-v-4fa986e5],.submit-btn[data-v-4fa986e5]{margin-top:190px}.dialog-image-box[data-v-4fa986e5]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-position:10px 100px;background-size:290px 290px}", ""]);
// Exports
module.exports = exports;
